(ns frontend.view.components.timeline.filters.view
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.view.components.timeline.filters.events :as events]
   [frontend.view.components.timeline.db :as db]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [ui.components.button.view :as button]))

(defn create-tooltip
  [text id]
  (r/as-element text))

(defn updates-btn
  [{:keys [updates]}]
  [button/square-secondary-open
   {:data-toggle  "button"
    :tooltip (-> :tooltip/updates-btn
                 loc/tr
                 (create-tooltip "updates"))
    :class        (fu/cs "toggle-btn" (when updates " active"))
    :aria-pressed (if updates "true" "false")
    :on-click     #(events/toggle-filter! :updates)}
   [:i.fal.fa-redo.fa-lg]])

(defn status-changes-btn
  [{:keys [status-changes]}]
  [button/square-secondary-open
   {:data-toggle  "button"
    :tooltip (-> :tooltip/status-changes-btn
                 loc/tr
                 (create-tooltip "status-changes"))
    :class        (fu/cs (when status-changes " active"))
    :aria-pressed (if status-changes "true" "false")
    :on-click     #(events/toggle-filter! :status-changes)}
   [:i.fal.fa-exchange.fa-lg]])

(defn comments-btn
  [{:keys [comments]}]
[button/square-secondary-open
 {:data-toggle  "button"
  :tooltip (-> :tooltip/comments-btn
               loc/tr
               (create-tooltip "comments"))
  :class        (fu/cs (when comments " active"))
  :aria-pressed (if comments "true" "false")
  :on-click     #(events/toggle-filter! :comments)}
 [:i.fal.fa-comments.fa-lg]])

(defn interactions-btn
  [{:keys [interactions]}]
  [button/square-secondary-open
   {:data-toggle  "button"
    :tooltip (-> :tooltip/interactions-btn
                 loc/tr
                 (create-tooltip "interactions"))
    :class        (fu/cs (when interactions " active"))
    :aria-pressed (if interactions "true" "false")
    :on-click     #(events/toggle-filter! :interactions)}
   [:i.fal.fa-users.fa-lg]])

(defn emails-btn
  [{:keys [emails]}]
  [button/square-secondary-open
   {:data-toggle  "button"
    :tooltip (-> :tooltip/emails-btn
                 loc/tr
                 (create-tooltip "emails"))
    :class        (fu/cs (when emails " active"))
    :aria-pressed (if emails "true" "false")
    :on-click     #(events/toggle-filter! :emails)}
   [:i.fal.fa-envelope.fa-lg]])

(defn component
  [filter-config]
  (when (some #{:updates :status-changes :comments :interactions :emails} filter-config)
    (let [state @db/filters-state]
      [:span.btn-group.zap-timeline-filters-tail
       [updates-btn state]
       [status-changes-btn state]
       [comments-btn state]
       [interactions-btn state]
       [emails-btn state]])))
